import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="sloading-container">
      <div className="sloading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
